// extracted by mini-css-extract-plugin
export default {"stack":"TechStack_stack__PpR5V","lineItem":"TechStack_lineItem__Ir1Oq","line":"TechStack_line__TqcRO"};